import { createUseStyles } from "react-jss";
import { Theme } from "../../../types/Theme";
import * as ChoiceTokens from "../../../theme/choiceThemeTokens";

export default createUseStyles(
    (theme: Theme) => {
        const useModernGridCell = ChoiceTokens.useModernChoiceStyles(theme);

        return {
            radio: {
                display: "inline-block",
                userSelect: "none",
                background: "transparent",
            },
            radioGridCell: {
                composes: useModernGridCell
                    ? ["radio__grid-cell", "radio__grid-cell--modern"]
                    : "radio__grid-cell",
                display: "flex",
                height: theme.GridCellMinHeight,
                margin: -theme.GridCellPadding,
                alignItems: "center",
                justifyContent: "center",
                ...(useModernGridCell
                    ? {
                          ...ChoiceTokens.modernGridMatrixCellFocusStyles(theme),
                          "&:hover": {
                              color: theme.PrimaryColor,
                          },
                      }
                    : {
                          "&:hover, &:focus": {
                              color: theme.PrimaryColor,
                          },
                      }),
            },
            radioGridCellChecked: {
                composes: "radio__grid-cell--checked",
                color: theme.PrimaryColor,
            },
            radioInput: {
                composes: "radio__input",
                display: "none",
            },
        } as any;
    },
);
